import React from 'react';

import styles from './styles.module.scss';

type Props = {
	description?: string;
	ctaLabel?: string;
	onCtaClick?: () => void;
};

const ExampleChartLabel: React.FC<Props> = ({ description, ctaLabel, onCtaClick }) => {
	return (
		<div className={styles['root']}>
			{description && <p className={styles['description']}>{description}</p>}
			<div
				className={`${styles['chip']}${onCtaClick ? ` ${styles['chip-cta']}` : ''}`}
				onClick={onCtaClick}
				role={onCtaClick ? 'button' : undefined}
			>
				{ctaLabel ?? 'Example data'}
			</div>
		</div>
	);
};

export default ExampleChartLabel;
